package com.shadowings.gero.data.lessons.chapter15

import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.data.repository.SentenceOptions
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.ImageKeyboardContent
import com.shadowings.gero.presentation.model.Verb
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.abydos_name_ab22
import gero.composeapp.generated.resources.abydos_name_ab23
import gero.composeapp.generated.resources.abydos_name_ab24
import gero.composeapp.generated.resources.abydos_name_ab27
import gero.composeapp.generated.resources.abydos_name_ab29
import gero.composeapp.generated.resources.exp_content_traduciamo_i_nomi_1
import gero.composeapp.generated.resources.exp_content_traduciamo_i_nomi_2
import gero.composeapp.generated.resources.exp_content_traduciamo_i_nomi_3
import gero.composeapp.generated.resources.exp_content_traduciamo_i_nomi_4
import gero.composeapp.generated.resources.exp_content_traduciamo_i_nomi_5
import gero.composeapp.generated.resources.exp_content_traduciamo_i_nomi_6
import gero.composeapp.generated.resources.exp_content_traduciamo_i_nomi_7
import gero.composeapp.generated.resources.exp_content_traduciamo_i_nomi_8
import gero.composeapp.generated.resources.exp_content_traduciamo_i_nomi_9
import gero.composeapp.generated.resources.exp_content_traduciamo_i_nomi_10
import gero.composeapp.generated.resources.exp_content_traduciamo_i_nomi_11
import gero.composeapp.generated.resources.exp_content_traduciamo_i_nomi_12
import gero.composeapp.generated.resources.exp_content_traduciamo_i_nomi_13
import gero.composeapp.generated.resources.exp_content_traduciamo_i_nomi_14
import gero.composeapp.generated.resources.exp_title_traduciamo_i_nomi
import kotlin.random.Random

fun getTraduciamoINomiContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_traduciamo_i_nomi,
            content = Res.string.exp_content_traduciamo_i_nomi_1,
            face = Faces.Surprised,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_traduciamo_i_nomi,
            content = Res.string.exp_content_traduciamo_i_nomi_2,
            face = Faces.Sad,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_traduciamo_i_nomi,
            content = Res.string.exp_content_traduciamo_i_nomi_3,
            face = Faces.Serious,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_traduciamo_i_nomi,
            content = Res.string.exp_content_traduciamo_i_nomi_4,
            face = Faces.Idle,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_traduciamo_i_nomi,
            content = Res.string.exp_content_traduciamo_i_nomi_5,
            face = Faces.Perfect,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_traduciamo_i_nomi,
            content = Res.string.exp_content_traduciamo_i_nomi_6,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_traduciamo_i_nomi,
            content = Res.string.exp_content_traduciamo_i_nomi_7,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_traduciamo_i_nomi,
            content = Res.string.exp_content_traduciamo_i_nomi_8,
            face = Faces.Doubt,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_traduciamo_i_nomi,
            content = Res.string.exp_content_traduciamo_i_nomi_9,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_traduciamo_i_nomi,
            content = Res.string.exp_content_traduciamo_i_nomi_10,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_traduciamo_i_nomi,
            content = Res.string.exp_content_traduciamo_i_nomi_11,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_traduciamo_i_nomi,
            content = Res.string.exp_content_traduciamo_i_nomi_12,
            face = Faces.Sad,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_traduciamo_i_nomi,
            content = Res.string.exp_content_traduciamo_i_nomi_13,
            face = Faces.Doubt,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_traduciamo_i_nomi,
            content = Res.string.exp_content_traduciamo_i_nomi_14,
            face = Faces.Perfect,
            character = Characters.Nilo,
        )
    )
}

// Throne names from the Abydos King List built with the signs of SIGNIFICATO_DEI_NOMI:
// image code (see InscriptionImages), words.tsv id (source of the reading), name with its meaning.
private val abydosMeaningNames = listOf(
    Triple("ab22", "DJEDEFRE", Res.string.abydos_name_ab22),
    Triple("ab23", "KHAFRE", Res.string.abydos_name_ab23),
    Triple("ab24", "MENKAURE", Res.string.abydos_name_ab24),
    Triple("ab27", "SAHURE", Res.string.abydos_name_ab27),
    Triple("ab29", "NEFEREFRE", Res.string.abydos_name_ab29),
)

// Same as nomiImportantiQuizWordIds: quiz-only names the Compendio unlocks on lesson completion.
val traduciamoINomiQuizWordIds: Set<String> = abydosMeaningNames.map { it.second }.toSet()

fun getTraduciamoINomiImageQuizContent(words: List<Word>): List<IQuizContent> =
    abydosMeaningNames.shuffled().mapNotNull { (imageCode, wordId, name) ->
        val word = words.firstOrNull { it.id == wordId } ?: return@mapNotNull null
        ImageKeyboardContent(
            imageCode = imageCode,
            reading = word.reading.lowercase().map { it.toString() },
            translation = name
        )
    }

// 5 random questions from the previous lesson's quiz + the 5 new cartouche photos.
fun getTraduciamoINomiQuizContent(
    hiero: List<Hiero>,
    words: List<Word> = emptyList(),
    verbs: List<Verb> = emptyList(),
    languageCode: String,
    verbSentences: List<SentenceOptions> = emptyList(),
    random: Random = Random
): List<IQuizContent> {
    val previous = getSignificatoDeiNomiQuizContent(
        hiero = hiero,
        words = words,
        verbs = verbs,
        languageCode = languageCode,
        verbSentences = verbSentences,
        random = random
    ).shuffled(random).take(5)

    return previous + getTraduciamoINomiImageQuizContent(words)
}
